import React from 'react'
import { Button, Col, FormGroup, Input, Label, Modal, ModalBody, ModalFooter, ModalHeader, Row } from 'reactstrap'
import Checkbox from './fields/checkbox'
import { API_ENDPOINT } from '../../constants';

class journalCuroflowFormComponent extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            journalUser: null,
            isNew: false,
            showChoiceModal: false,
            showExistingDoctorList: false,
            allClinicUsers: []
        };
    }

    get = async (userId) => {
        try {
            const response = await fetch(`${API_ENDPOINT}/journal-curoflow/clinic-user/${userId}`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${localStorage.getItem('authToken')}`,
                },
                body: JSON.stringify({ groupId: this.props.group }),
            });

            const result = await response.json();

            let journalUser = { ...this.props.user };
            if (!journalUser.journalCuroflow) journalUser.journalCuroflow = {};
            if (!journalUser.journalCuroflow[this.props.group]) journalUser.journalCuroflow[this.props.group] = {};
            if (!journalUser.journalCuroflow[this.props.group].permissions) journalUser.journalCuroflow[this.props.group].permissions = {};

            if (result?.createNew) {
                journalUser.title = this.props.user?.userData?.title || '';
                journalUser.ssn = this.props.user?.socialSecurityNumber || '';
                if (!journalUser.contacts) journalUser.contacts = {};
                if (!journalUser.contacts[this.props.group]) journalUser.contacts[this.props.group] = {};
                journalUser.contacts[this.props.group].email = this.props.user?.contacts?.[this.props.group]?.email || '';
                journalUser.contacts[this.props.group].phone = this.props.user?.contacts?.[this.props.group]?.phone || '';
                this.setState({ isNew: true, showChoiceModal: true });

                journalUser.journalCuroflow[this.props.group].permissions = {
                    readPatients: true,
                    readPatientNotes: true,
                    readPatientLabResults: true,
                    readPatientDocuments: true,
                    readPatientJournalNotes: true,
                    readPatientJournalTemplates: true,
                    readPatientHealthFlags: true,
                    readPatientVitalLogs: true,
                    readPatientVaccination: true,
                    readPatientPrescription: true,
                    readPatientPreviousRecords: true,
                    writePatients: true,
                    writePatientNotes: true,
                    writePatientLabResults: true,
                    writePatientDocuments: true,
                    writePatientJournalNotes: true,
                    writePatientJournalTemplates: true,
                    writePatientHealthFlags: true,
                    writePatientVitalLogs: true,
                    writePatientVaccination: true,
                    writePatientPrescription: true,
                };
            } else {
                const jcData = result?.data || {};
                const read = jcData.permissions?.read || {};
                const write = jcData.permissions?.write || {};

                journalUser.name = jcData.name || '';
                journalUser.title = jcData.title || '';
                journalUser.ssn = jcData.ssn || '';
                journalUser.username = jcData.username || '';
                if (!journalUser.contacts) journalUser.contacts = {};
                if (!journalUser.contacts[this.props.group]) journalUser.contacts[this.props.group] = {};
                journalUser.contacts[this.props.group].email = jcData.email || '';
                journalUser.contacts[this.props.group].phone = jcData.phone || '';

                journalUser.journalCuroflow[this.props.group].active = true;
                if (jcData.id) journalUser.journalCuroflow[this.props.group].id = jcData.id;

                journalUser.journalCuroflow[this.props.group].permissions = {
                    readPatients: read.patients || false,
                    readPatientDocuments: read.patient_documents || false,
                    readPatientHealthFlags: read.patient_health_flags || false,
                    readPatientLabResults: read.patient_lab_results || false,
                    readPatientNotes: read.patient_notes || false,
                    readPatientVaccination: read.patient_vaccination || false,
                    readPatientPrescription: read.patient_prescription || false,
                    readPatientVitalLogs: read.patient_vital_logs || false,
                    readPatientJournalNotes: read.journal_notes || false,
                    readPatientJournalTemplates: read.journal_templates || false,
                    readPatientPreviousRecords: read.patient_previous_records || false,

                    writePatients: write.patients || false,
                    writePatientDocuments: write.patient_documents || false,
                    writePatientHealthFlags: write.patient_health_flags || false,
                    writePatientLabResults: write.patient_lab_results || false,
                    writePatientNotes: write.patient_notes || false,
                    writePatientVaccination: write.patient_vaccination || false,
                    writePatientPrescription: write.patient_prescription || false,
                    writePatientVitalLogs: write.patient_vital_logs || false,
                    writePatientJournalNotes: write.journal_notes || false,
                    writePatientJournalTemplates: write.journal_templates || false,
                };
            }

            this.setState({ journalUser });
        } catch (err) {
            console.error('Error fetching journal clinic user:', err);
        }
    }

    getAllClinicUsers = async (userId) => {
        try {
            const response = await fetch(`${API_ENDPOINT}/journal-curoflow/clinic-user/get-all`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${localStorage.getItem('authToken')}`,
                },
                body: JSON.stringify({ groupId: this.props.group, id: userId }),
            });

            const result = await response.json();
            this.setState({ allClinicUsers: result?.data || [] });
        } catch (err) {
            console.error('Error fetching clinic users', err);
        }
    }

    connectClinicUser = async (userId, journalUserId) => {
        try {
            await fetch(`${API_ENDPOINT}/journal-curoflow/clinic-user/${userId}/connect/${journalUserId}`, {
                method: "PUT",
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${localStorage.getItem('authToken')}`,
                },
                body: JSON.stringify({ groupId: this.props.group })
            });
        } catch (err) {
            console.error("Error connecting clinic user", err);
        }
    }

    componentDidMount() {
        if (this.props.user?._id) {
            this.get(this.props.user._id);
        }
    }

    componentDidUpdate(prevProps) {
        if (prevProps.user !== this.props.user && this.props.user?._id) {
            this.get(this.props.user._id);
        }
    }

    render() {
        const isConnectedToJournal = !this.state.isNew &&
            this.state.journalUser?.journalCuroflow?.[this.props.group]?.active &&
            this.state.journalUser?.journalCuroflow?.[this.props.group]?.id

        return (
            <>
                {this.state.showChoiceModal && (
                    <Modal isOpen centered>
                        <ModalHeader close={<button type="button" className="close" style={{ position: 'absolute', top: '15px', right: '15px' }} onClick={() => {
                            this.props.onCancel();
                        }}>&times;</button>}>{'Journal Curoflow User'.translate(this.props.lang)}</ModalHeader>
                        <ModalBody>
                            <p>{'How would you like to connect this user to Journal Curoflow?'.translate(this.props.lang)}</p>
                            <div style={{ display: 'flex', gap: '10px' }}>
                                <Button color='primary' onClick={() => {
                                    this.setState({ showChoiceModal: false, showExistingDoctorList: true });
                                    this.getAllClinicUsers(this.props.user._id);
                                }}>
                                    {'Connect existing user'.translate(this.props.lang)}
                                </Button>
                                <Button color='primary' onClick={() => this.setState({ showChoiceModal: false })}>
                                    {'Create new user'.translate(this.props.lang)}
                                </Button>
                            </div>
                        </ModalBody>
                    </Modal>
                )}

                {this.state.showExistingDoctorList && (
                    <Modal isOpen centered size={'lg'}>
                        <ModalHeader close={<button type="button" className="close" style={{ position: 'absolute', top: '15px', right: '15px' }} onClick={() => {
                            this.setState({ showExistingDoctorList: false });
                            this.props.onCancel();
                        }}>&times;</button>}>
                            {'Connect with existing user in journal'.translate(this.props.lang)}
                        </ModalHeader>
                        <ModalBody>
                            <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                                {this.state.allClinicUsers.map(doctor => (
                                    <div key={doctor?.id} style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '10px 12px', border: '1px solid #dee2e6', borderRadius: '6px' }}>
                                        <div>
                                            <div style={{ fontWeight: 600 }}>{[doctor?.title, doctor?.name].filter(Boolean).join(' ')}</div>
                                            <div style={{ fontSize: '13px', color: '#6c757d' }}>
                                                {[doctor?.username, doctor?.email, doctor?.phone, doctor?.ssn].filter(Boolean).join(' · ')}
                                            </div>
                                        </div>
                                        <Button color='primary' size='sm' onClick={() => {
                                            this.connectClinicUser(this.props.user?._id, doctor?.id)
                                            this.props.onCancel();
                                        }}>
                                            {'Select'.translate(this.props.lang)}
                                        </Button>
                                    </div>
                                ))}
                                {!this.state.allClinicUsers.length && (
                                    <p style={{ textAlign: 'center', color: '#6c757d', margin: '20px 0' }}>{'No doctors found'.translate(this.props.lang)}</p>
                                )}
                            </div>
                        </ModalBody>
                        <ModalFooter style={{ justifyContent: 'flex-end', display: 'flex' }} className="buttons-right-blue">
                            <Button color='secondary' onClick={() => {
                                this.setState({ showExistingDoctorList: false });
                                this.props.onCancel();
                            }}>{'Cancel'.translate(this.props.lang)}</Button>
                        </ModalFooter>
                    </Modal>
                )}

                <Modal isOpen={!!(this.state.journalUser && !this.state.showChoiceModal && !this.state.showExistingDoctorList)} centered size={'lg'}>
                    <ModalHeader close={<button type="button" className="close" style={{ position: 'absolute', top: '15px', right: '15px' }} onClick={() => {
                        this.props.onCancel();
                    }}>&times;</button>}>{'Journal Curoflow User'.translate(this.props.lang)}</ModalHeader>
                    <ModalBody>
                        <Row>
                            <Col lg={3}>
                                <FormGroup >
                                    <Label >{"Title".translate(this.props.lang)}</Label>
                                    <Input type="text" value={this.state.journalUser?.title || ''}
                                        onChange={(e) => this.setState({ journalUser: { ...this.state.journalUser, title: e.target.value } })} />
                                </FormGroup>
                            </Col>
                            <Col lg={5}>
                                <FormGroup >
                                    <Label >{"Name".translate(this.props.lang)}</Label>
                                    <Input type="text" value={this.state.journalUser?.name || ''}
                                        onChange={(e) => this.setState({ journalUser: { ...this.state.journalUser, name: e.target.value } })} />
                                </FormGroup>
                            </Col>
                            <Col lg={4}>
                                <FormGroup >
                                    <Label >{"SSN".translate(this.props.lang)}</Label>
                                    <Input type="text" value={this.state.journalUser?.ssn || ''}
                                        onChange={(e) => this.setState({ journalUser: { ...this.state.journalUser, ssn: e.target.value } })} />
                                </FormGroup>
                            </Col>
                        </Row>
                        <Row>
                            <Col lg={4}>
                                <FormGroup >
                                    <Label >{"Username".translate(this.props.lang)}</Label>
                                    <Input type="text" value={this.state.journalUser?.username || ''}
                                        onChange={(e) => this.setState({ journalUser: { ...this.state.journalUser, username: e.target.value } })} />
                                </FormGroup>
                            </Col>
                            <Col lg={4}>
                                <FormGroup >
                                    <Label >{"Email".translate(this.props.lang)}</Label>
                                    <Input type="text" value={this.state.journalUser?.contacts?.[this.props.group]?.email || ''}
                                        onChange={(e) => {
                                            let journalUser = { ...this.state.journalUser };
                                            if (!journalUser.contacts) journalUser.contacts = {};
                                            if (!journalUser.contacts[this.props.group]) journalUser.contacts[this.props.group] = {};
                                            journalUser.contacts[this.props.group].email = e.target.value;
                                            this.setState({ journalUser });
                                        }} />
                                </FormGroup>
                            </Col>
                            <Col lg={4}>
                                <FormGroup >
                                    <Label >{"Phone".translate(this.props.lang)}</Label>
                                    <Input type="text" value={this.state.journalUser?.contacts?.[this.props.group]?.phone || ''}
                                        onChange={(e) => {
                                            let journalUser = { ...this.state.journalUser };
                                            if (!journalUser.contacts) journalUser.contacts = {};
                                            if (!journalUser.contacts[this.props.group]) journalUser.contacts[this.props.group] = {};
                                            journalUser.contacts[this.props.group].phone = e.target.value;
                                            this.setState({ journalUser });
                                        }} />
                                </FormGroup>
                            </Col>
                        </Row>
                        <Row>
                            <Col lg={12}>
                                <Label >{"Permissions".translate(this.props.lang)}</Label>
                            </Col>
                        </Row>
                        <Row>
                            <Col lg={6}>
                                {Object.keys(this.state.journalUser?.journalCuroflow?.[this.props.group]?.permissions || {})
                                    .filter(key => key.startsWith('read'))
                                    .map(key => {
                                        const writeKey = 'write' + key.slice(4);
                                        const isDisabled = !!this.state.journalUser?.journalCuroflow?.[this.props.group]?.permissions?.[writeKey];
                                        const label = (key.charAt(0).toUpperCase() + key.slice(1)).replace(/([A-Z])/g, ' $1').trim();
                                        return (
                                            <FormGroup key={key}>
                                                <Checkbox
                                                    disabled={isDisabled}
                                                    label={label.translate(this.props.lang)}
                                                    checked={!!this.state.journalUser?.journalCuroflow?.[this.props.group]?.permissions?.[key]}
                                                    onChange={(e) => {
                                                        let journalUser = { ...this.state.journalUser };
                                                        if (!journalUser.journalCuroflow) journalUser.journalCuroflow = {};
                                                        if (!journalUser.journalCuroflow[this.props.group]) journalUser.journalCuroflow[this.props.group] = {};
                                                        if (!journalUser.journalCuroflow[this.props.group].permissions) journalUser.journalCuroflow[this.props.group].permissions = {};
                                                        journalUser.journalCuroflow[this.props.group].permissions[key] = e.target.checked;
                                                        this.setState({ journalUser });
                                                    }}
                                                />
                                            </FormGroup>
                                        );
                                    })
                                }
                            </Col>

                            <Col lg={6}>
                                {Object.keys(this.state.journalUser?.journalCuroflow?.[this.props.group]?.permissions || {})
                                    .filter(key => key.startsWith('write'))
                                    .map(key => {
                                        const readKey = 'read' + key.slice(5);
                                        const label = (key.charAt(0).toUpperCase() + key.slice(1)).replace(/([A-Z])/g, ' $1').trim();
                                        return (
                                            <FormGroup key={key}>
                                                <Checkbox
                                                    label={label.translate(this.props.lang)}
                                                    checked={!!this.state.journalUser?.journalCuroflow?.[this.props.group]?.permissions?.[key]}
                                                    onChange={(e) => {
                                                        let journalUser = { ...this.state.journalUser };
                                                        if (!journalUser.journalCuroflow) journalUser.journalCuroflow = {};
                                                        if (!journalUser.journalCuroflow[this.props.group]) journalUser.journalCuroflow[this.props.group] = {};
                                                        if (!journalUser.journalCuroflow[this.props.group].permissions) journalUser.journalCuroflow[this.props.group].permissions = {};
                                                        journalUser.journalCuroflow[this.props.group].permissions[key] = e.target.checked;
                                                        if (e.target.checked) {
                                                            journalUser.journalCuroflow[this.props.group].permissions[readKey] = true;
                                                        }
                                                        this.setState({ journalUser });
                                                    }}
                                                />
                                            </FormGroup>
                                        );
                                    })
                                }
                            </Col>
                        </Row>

                    </ModalBody>
                    <ModalFooter style={{ margin: 'unset', justifyContent: 'flex-end', display: 'flex', width: '100%' }} className="buttons-right-blue">
                        {
                            isConnectedToJournal ?
                                <>
                                    <div className='red-button-wrap'>
                                        <Button onClick={() => {
                                            this.props.onDisconnect(this.state.journalUser);
                                            this.props.onCancel();
                                        }} color='danger'>{"Disconnect user".translate(this.props.lang)}</Button>
                                    </div>
                                    <Button onClick={() => {
                                        this.props.onUpdate(this.state.journalUser);
                                        this.props.onCancel();
                                    }} color='primary'>{"Update".translate(this.props.lang)}</Button>

                                </>
                                :
                                <Button onClick={() => {
                                    this.props.onSave(this.state.journalUser);
                                    this.props.onCancel();
                                }} color='primary'>{"Save".translate(this.props.lang)}</Button>
                        }
                    </ModalFooter>
                </Modal>
            </>
        )
    }
}

export default journalCuroflowFormComponent
